import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreatePlanReviewCheckoutMutationVariables = Types.Exact<{
  input: Types.CreatePlanReviewCheckoutInput;
}>;


export type CreatePlanReviewCheckoutMutation = { __typename?: 'mutation_root', create_plan_review_checkout?: { __typename?: 'CreatePlanReviewCheckoutOutput', checkout_url: string } | null };


export const CreatePlanReviewCheckoutDocument = gql`
    mutation createPlanReviewCheckout($input: CreatePlanReviewCheckoutInput!) {
  create_plan_review_checkout(input: $input) {
    checkout_url
  }
}
    `;
export type CreatePlanReviewCheckoutMutationFn = Apollo.MutationFunction<CreatePlanReviewCheckoutMutation, CreatePlanReviewCheckoutMutationVariables>;

/**
 * __useCreatePlanReviewCheckoutMutation__
 *
 * To run a mutation, you first call `useCreatePlanReviewCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlanReviewCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlanReviewCheckoutMutation, { data, loading, error }] = useCreatePlanReviewCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlanReviewCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlanReviewCheckoutMutation, CreatePlanReviewCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlanReviewCheckoutMutation, CreatePlanReviewCheckoutMutationVariables>(CreatePlanReviewCheckoutDocument, options);
      }
export type CreatePlanReviewCheckoutMutationHookResult = ReturnType<typeof useCreatePlanReviewCheckoutMutation>;
export type CreatePlanReviewCheckoutMutationResult = Apollo.MutationResult<CreatePlanReviewCheckoutMutation>;
export type CreatePlanReviewCheckoutMutationOptions = Apollo.BaseMutationOptions<CreatePlanReviewCheckoutMutation, CreatePlanReviewCheckoutMutationVariables>;